import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Main, PageLoader, Error, Dashboard, Button } from "components";
import { client } from "utils/api";
import useGet from "hooks/useGet";
import { ReactComponent as CategoryIcon } from "icons/category.svg";

import Tree from "./components/Tree";

const csv_headers = ["nazwa", "kodID", "kodAukcje"];

const createRootTaxonCsv = async (setCsvData, setDownloadingCsvData) => {
  try {
    const { data } = await client.get(
      "/root_taxons?per_page=100000&context=csv",
    );

    setCsvData(data.map(({ name, identifier }) => [name, identifier]));
    setDownloadingCsvData(false);
  } catch (error) {}
};

const RootTaxonsList = () => {
  const [is_downloading_csv_data, setDownloadingCsvData] = useState(true);
  const [csv_data, setCsvData] = useState([]);

  useEffect(() => {
    createRootTaxonCsv(setCsvData, setDownloadingCsvData);
  }, []);

  const { is_loading, is_error, error, data } = useGet({
    query: ["root_taxons"],
    path: "/root_taxons",
    search: {
      page: 1,
      per_page: 1_000,
      "q[ancestry_blank]": true,
    },
    context: "ui_index",
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }
  return (
    <Main
      page={{
        name: "Root",
        icon: <CategoryIcon />,
        breadcrumbs: [
          {
            name: "Kategorie root",
            path: "/root_taxons",
          },
          { name: "Root" },
        ],
        buttons: (
          <>
            <CSVLink
              className="btn-sm btn-blue"
              disabled={is_downloading_csv_data}
              headers={csv_headers}
              data={csv_data}
              filename="root_taxons.csv"
            >
              <span>Pobierz CSV</span>
            </CSVLink>
            <Button type="add" text="Dodaj kategorię" path="/root_taxons/new" />
          </>
        ),
      }}
    >
      <Dashboard>
        <Tree
          head={["Nazwa", "Identyfikator"]}
          data={data}
          row_data={["identifier"]}
        />
      </Dashboard>
    </Main>
  );
};

export default RootTaxonsList;
